import styled from 'styled-components';
import { device } from '@stockbit/ui';

// copy from web legacy in build.css
const OnBoardingWrapper = styled.div`
  .hide {
    display: none !important;
  }

  .boarding-cover {
    font-size: 16px;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
    border: 1px solid #dadada;
    width: 100%;
    margin: auto;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: table;
    position: fixed;
  }

  .boarding-content {
    transform-origin: bottom center;
    animation: fade-in-pulse 0.3s forwards cubic-bezier(0.8, 0.02, 0.45, 0.91);

    text-align: center;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #fff;

    &.ob-discover {
      @media only screen and (max-height: 600px) {
        justify-content: flex-start;
        overflow: auto;
        padding-top: 60px;
      }
    }
  }

  .boarding-in {
    width: 600px;

    position: relative;
    text-align: center;
    display: table-cell;
    vertical-align: middle;

    @media only screen and (max-width: 500px) {
      width: 100%;
    }
  }

  .boarding-title {
    font-size: 18px;
    font-family: var(--bold-font);
    margin-bottom: 10px;

    @media only screen and (max-width: 500px) {
      margin-bottom: 20px;
    }
  }

  .boarding-text {
    line-height: 1.3;
    font-size: 14px;

    @media only screen and (max-width: 500px) {
      padding: 0 20px;
    }
  }

  .boarding-skip {
    margin: 10px 0;
    color: #b5b5b5;
    font-size: 13px;
    margin-top: 20px;
    cursor: pointer;

    &:hover {
      color: #333;
    }
  }

  .boarding-button-next {
    display: inline-block;
    margin: 20px 0 30px;
    padding: 0 15px;
    line-height: 40px;
    height: 40px;
    border-radius: 2px;
    background: #b5b5b5;
    color: #fff;
    cursor: pointer;
    transition: all 0.1s cubic-bezier(0.98, 0.01, 1, 1);
  }

  .boarding-button-next:hover,
  .boarding-button-finish:hover {
    background: #00ab6b;
  }

  .PrimarySpinner {
    min-width: 100px;
    min-height: 100px;
    position: relative;
  }

  .PrimarySpinner:before {
    content: 'Loading…';
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    margin-top: 0;
    margin-left: 0;
  }

  .PrimarySpinner:before {
    content: '';
    border-radius: 50%;
    border-top: 2px solid #ccc;
    border-right: 2px solid transparent;
    animation: spinner 0.7s linear infinite;
    -webkit-animation: spinner 0.7s linear infinite;
  }

  .boarding-button-back {
    color: #b5b5b5;
    position: absolute;
    top: 2px;
    left: 0px;
    cursor: pointer;
  }

  @media only screen and (max-width: 500px) {
    .boarding-button-back {
      left: 20px !important;
    }
  }
`;

export default OnBoardingWrapper;
